exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n/* Context Menu */\n._3pXEORTNy0NxwBkynS9Var {\n    position: absolute;\n    background-color: #f1f1f1;\n    min-width: 160px;\n    -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n  }\n  \n  ._3pXEORTNy0NxwBkynS9Var a {\n    color: black;\n    padding: 12px 10px;\n    text-decoration: none;\n    display: block;\n  }\n  \n  ._3pXEORTNy0NxwBkynS9Var a:hover {\n    background-color: #ddd;\n  }", ""]);

// exports
exports.locals = {
	"dropdownContent": "_3pXEORTNy0NxwBkynS9Var"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/ContextMenu/ContextMenu.css
// module id = 10461
// module chunks = 23